import { combineReducers } from 'redux';
//
import auth from './auth';
import common from './common';
import loading from './loading';
import pagination from './pagination';

const createRootReducer = combineReducers({
  auth,
  loading,
  common,
  pagination,
});

export default createRootReducer;
